import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { useWindowSize } from '@app/hooks';
import { useSuppliersHeader } from '@app/pages/Warehouses/Suppliers/hooks';

export const SuppliersHeader = () => {
  const { goToAddSupplier, IsSupplierCreate } = useSuppliersHeader();

  const { isMobile } = useWindowSize();

  if (!IsSupplierCreate) {
    return null;
  }

  return (
    <Button
      className={isMobile ? 'full-width' : ''}
      type="primary"
      onClick={goToAddSupplier}
      icon={<PlusOutlined />}
    >
      Добавить поставщика
    </Button>
  );
};
